import type { GiftContacts } from '@diana/contracts';
import './GiftContactsPanel.css';
export function GiftRoleLabels({ clientId, roles }: { clientId: string; roles: GiftContacts }) {
  return (
    <span className="gift-contact-roles">
      {clientId === roles.buyerId ? <span>Buyer</span> : null}
      {clientId === roles.recipientId ? <span>Recipient</span> : null}
    </span>
  );
}
